import turbolinksLoadedObservable from '@newswebsiteapp/shared/observables/turbolinksLoadedObservable'

turbolinksLoadedObservable.subscribe(() => {
  $('.easy-embed').each(function () {
    $(this).easyEmbed()
  })
})
